var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g2, _path39, _path40, _g3, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiringEngagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9294 380.186C91.571 367.539 94.1054 354.637 101.017 343.45C107.929 332.262 119.449 322.867 133.529 318.925C151.526 313.856 171.033 317.952 189.798 320.23C214.579 323.251 241.485 322.662 262.4 310.963C278.707 301.85 289.536 286.976 305.229 277.12C333.696 259.251 375.705 261.427 404.326 279.117C432.947 296.806 448.307 327.603 448.333 357.76C448.358 391.27 429.696 424.141 400.025 445.952H121.625C103.833 427.315 92.6462 404.147 91.9294 380.186Z",
    stroke: "#D3DFFF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M448.333 371.072C448.691 356.684 446.208 342.016 439.526 329.267C432.819 316.518 421.632 305.843 407.961 301.363C390.476 295.603 371.532 300.262 353.305 302.848C329.241 306.278 303.129 305.612 282.803 292.3C266.982 281.907 256.461 265.011 241.203 253.798C213.555 233.472 172.774 235.955 144.973 256.076C117.171 276.198 102.272 311.244 102.246 345.548C102.221 383.667 120.345 421.068 149.145 445.875H419.481C436.787 424.704 447.641 398.336 448.333 371.072Z",
    fill: "#EDF2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M241.868 418.79C238.54 421.196 235.109 422.912 230.501 423.731L231.602 427.033C223.538 436.531 222.13 442.393 223.333 445.772L248.216 431.155L241.868 418.79Z",
    fill: "#102048"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M235.928 404.582L225.688 409.139L230.526 423.731C235.16 422.912 238.59 421.171 241.892 418.79L235.928 404.582Z",
    fill: "#F9B384"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.842 432.076V416.204L166.911 415.974L164.684 431.948C169.496 432.818 173.848 432.818 177.842 432.076Z",
    fill: "#F9B384"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.658 431.948L164.146 435.583C152.268 439.398 148.504 442.316 147.736 445.823H177.816V432.076C173.848 432.819 169.496 432.819 164.658 431.948Z",
    fill: "#102048"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M213.81 289.331L192.741 315.084L191.256 316.902L188.876 342.399L181.119 425.343L161.074 424.883C159.282 371.046 156.696 315.084 162.559 277.273L164.607 263.833L212.453 267.238L213.81 289.331Z",
    fill: "#1F3C88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.184 206.361L122.674 204.646C121.752 203.622 120.421 203.033 119.064 203.11L100.018 203.904C99.9157 203.904 99.8645 204.057 99.9413 204.109C104.063 207.309 109.208 208.973 115.071 209.561L120.933 217.6L124.184 206.361Z",
    fill: "#F9B384"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M192.74 315.059L191.256 316.877L188.875 342.374C181.528 326.477 183.755 303.667 183.755 303.667L192.74 315.059Z",
    fill: "#102048"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M213.81 289.331C219.033 328.755 229.631 371.123 242.636 412.441L223.845 418.944C200.831 369.638 191.615 342.963 183.756 303.693L213.81 289.331Z",
    fill: "#1F3C88"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M191.435 197.17L188.184 211.071L195.198 218.137L203.697 216.422L205.643 196.505L191.435 197.17Z",
    fill: "#F9B384"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M167.014 275.148C176.588 277.375 189.567 282.828 205.977 277.887L208.025 270.361L168.55 269.337L167.014 275.148Z",
    fill: "#102048"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M188.544 208.332C188.544 208.332 194.688 217.548 204.262 211.404L212.812 226.278L208.896 272.742C194.56 278.246 180.736 276.428 167.219 270.361L177.459 216.038L188.544 208.332Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.672 214.221C188.619 215.526 189.72 216.627 191 217.472C192.28 218.291 193.688 218.88 195.147 219.161C196.606 219.443 198.117 219.418 199.601 219.085C201.086 218.752 202.494 218.086 203.851 217.19C202.878 218.496 201.496 219.52 199.909 220.109C198.321 220.698 196.555 220.826 194.891 220.518C193.227 220.186 191.64 219.443 190.36 218.342C189.08 217.216 188.107 215.782 187.672 214.221Z",
    fill: "#1F3C88"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M188.8 208.512L175.769 208.461C171.596 208.486 167.526 209.613 163.916 211.686L146.355 221.824L124.211 206.336L115.148 216.243L137.728 235.571C141.312 238.515 146.099 239.488 150.553 238.182L164.3 234.138L150.451 284.186C160.153 286.925 167.654 288.717 176.768 285.389C181.708 274.125 190.387 247.168 188.8 208.512Z",
    fill: "#708CD5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M190.923 183.219C190.923 183.219 187.211 183.756 183.755 178.355C180.529 173.311 185.956 161.638 195.377 166.476C201.368 160.665 209.918 163.276 215.806 171.724C215.806 171.724 218.008 171.468 220.158 174.182C223.051 177.843 221.822 189.772 212.913 194.508L190.923 183.219Z",
    fill: "#102048"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M190.719 200.166C190.719 200.166 192.434 205.747 196.556 206.464C201.855 207.411 204.44 201.164 204.44 201.164L190.719 200.166Z",
    fill: "#E28B6D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M213.016 181.068L211.941 191.283C211.941 191.283 210.123 197.503 203.902 202.444C197.681 207.385 189.336 202.111 188.926 195.046C188.926 194.969 188.926 194.892 188.901 194.815C188.798 192.895 188.773 191.103 188.849 189.465C189.08 182.681 190.488 178.508 190.488 178.508L201.547 173.798L213.016 181.068Z",
    fill: "#F9B384"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M211.584 189.9C208.64 188.62 207.488 185.651 207.385 181.683C201.088 183.142 195.225 182.528 189.747 180.326L186.777 174.848L199.347 170.086L213.683 173.875L216.832 183.372L211.584 189.9Z",
    fill: "#102048"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M202.264 188.646C202.059 189.414 201.47 189.901 200.933 189.747C200.395 189.593 200.139 188.877 200.344 188.109C200.549 187.341 201.137 186.854 201.675 187.008C202.213 187.136 202.469 187.878 202.264 188.646Z",
    fill: "#102048"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M193.685 187.086C193.822 186.321 193.494 185.621 192.951 185.524C192.408 185.426 191.857 185.968 191.719 186.733C191.582 187.499 191.911 188.198 192.453 188.296C192.996 188.393 193.548 187.851 193.685 187.086Z",
    fill: "#102048"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M196.223 186.47C196.453 187.212 196.351 188.057 195.967 188.774C195.788 189.132 195.506 189.465 195.199 189.721C194.892 189.977 194.559 190.156 194.328 190.361C194.098 190.566 193.919 190.796 193.868 191.027C193.816 191.231 193.893 191.462 194.072 191.769C194.456 192.358 194.866 192.972 195.224 193.612L194.968 193.817C194.431 193.305 193.944 192.793 193.458 192.204C193.228 191.923 192.972 191.436 193.074 190.899C193.176 190.412 193.484 190.054 193.816 189.772C194.149 189.516 194.456 189.337 194.712 189.132C194.968 188.953 195.173 188.697 195.352 188.441C195.711 187.903 195.916 187.238 195.89 186.547L196.223 186.47Z",
    fill: "#E28B6D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M199.371 185.318C200.113 184.781 201.086 184.397 202.11 184.525C202.622 184.602 203.109 184.806 203.493 185.139C203.877 185.446 204.158 185.856 204.363 186.291L204.133 186.445C203.467 185.83 202.801 185.318 201.982 185.216C201.189 185.088 200.318 185.318 199.448 185.574L199.371 185.318Z",
    fill: "#102048"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M191.281 183.962C191.588 183.68 191.947 183.45 192.331 183.27C192.715 183.091 193.176 183.014 193.636 183.04C194.097 183.091 194.558 183.296 194.865 183.603C195.198 183.91 195.428 184.269 195.582 184.678L195.352 184.832C194.788 184.269 194.225 183.808 193.534 183.731C192.868 183.654 192.126 183.91 191.384 184.192L191.281 183.962Z",
    fill: "#102048"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M193.432 195.635L198.629 195.788C198.476 196.812 198.066 197.657 197.349 198.272C196.402 199.091 194.917 198.988 194.124 198.041C193.586 197.376 193.33 196.582 193.432 195.635Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M205.468 195.629C206.558 194.54 206.558 192.773 205.468 191.683C204.378 190.593 202.612 190.593 201.522 191.683C200.432 192.773 200.432 194.54 201.522 195.629C202.612 196.719 204.378 196.719 205.468 195.629Z",
    fill: "#FC8879"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M190.897 192.153C190.897 193.407 190.053 194.482 188.901 194.815C188.798 192.895 188.773 191.103 188.849 189.465C190.001 189.772 190.897 190.847 190.897 192.153Z",
    fill: "#FC8879"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M224.766 260.786L218.622 290.687L232.753 290.226L238.283 268.287C240.92 257.817 240.152 246.758 235.953 236.825C233.905 231.961 231.32 226.79 228.273 221.414C226.814 218.828 224.408 216.908 221.54 216.14L204.235 211.43C195.71 237.772 191.742 263.167 195.838 286.822L215.371 284.364C215.627 271.334 215.294 256.793 219.979 239.257C219.979 239.257 225.432 246.783 224.766 260.786Z",
    fill: "#708CD5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M209.254 189.619C211.584 187.878 212.787 187.75 214.323 189.081C216.166 190.72 215.68 197.811 208.512 195.251L209.254 189.619Z",
    fill: "#F9B384"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M210.431 192.025C210.354 191.615 210.405 191.18 210.585 190.796C210.764 190.412 211.071 190.079 211.429 189.849C211.788 189.618 212.223 189.49 212.684 189.516C213.119 189.542 213.605 189.798 213.785 190.207L213.58 190.361C213.298 190.156 212.991 190.105 212.709 190.13C212.402 190.156 212.095 190.258 211.813 190.438C211.25 190.77 210.866 191.334 210.713 192.05H210.431V192.025Z",
    fill: "#E28B6D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M166.183 226.377L161.316 243.811L161.982 243.996L166.849 226.563L166.183 226.377Z",
    fill: "#102048"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M218.086 248.704L217.42 248.601C217.932 245.196 221.055 233.523 221.183 233.011L221.849 233.19C221.798 233.318 218.598 245.35 218.086 248.704Z",
    fill: "#102048"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M236.184 314.034C233.65 316.466 230.782 318.335 227.71 319.615C225.176 320.69 222.539 321.356 219.826 321.638C216.293 322.022 212.683 321.714 209.253 320.716C206.13 319.82 203.134 318.386 200.421 316.39C199.166 315.468 197.989 314.444 196.862 313.266C191.666 307.865 189.08 300.927 189.08 293.99C189.08 286.694 191.922 279.423 197.579 273.97C198.757 272.844 199.986 271.846 201.266 270.975C202.597 270.054 204.005 269.286 205.438 268.646C206.411 268.21 207.435 267.826 208.434 267.494C209.816 267.058 211.224 266.726 212.632 266.495C216.19 265.958 219.851 266.111 223.358 266.956C225.099 267.366 226.814 267.954 228.478 268.722C230.526 269.67 232.472 270.847 234.264 272.306C235.186 273.023 236.056 273.842 236.875 274.687C247.576 285.798 247.243 303.385 236.184 314.034Z",
    fill: "#FBC343"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M232.907 278.604C233.061 278.783 233.215 278.963 233.368 279.142C240.715 288.025 240.101 301.209 231.653 309.35C230.757 310.195 229.835 310.963 228.837 311.654C226.405 313.343 223.717 314.47 220.927 315.084C217.189 315.903 213.298 315.724 209.637 314.598C206.539 313.651 203.621 312.012 201.112 309.708C201.01 309.631 200.933 309.555 200.831 309.452C192.997 300.569 193.483 287.001 202.085 278.707C202.879 277.939 203.723 277.247 204.594 276.633C206.949 274.943 209.535 273.791 212.223 273.126C217.317 271.871 222.744 272.46 227.506 274.815C229.451 275.788 231.269 277.043 232.907 278.604Z",
    fill: "#BB9132"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M233.522 279.398C233.753 279.628 233.983 279.884 234.188 280.14C225.612 271.974 212.044 271.923 203.468 280.191C194.892 288.46 194.431 302.003 202.265 310.886C202.034 310.655 201.778 310.425 201.548 310.195C193.023 301.337 193.253 287.257 202.085 278.758C210.917 270.259 224.972 270.54 233.522 279.398Z",
    fill: "#BB9132"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M212.683 266.547L212.273 273.126V273.152C211.71 273.28 211.147 273.459 210.609 273.638C210.507 273.664 210.43 273.689 210.328 273.74C210.251 273.766 210.174 273.792 210.072 273.817C210.046 273.817 210.046 273.817 210.021 273.843C209.278 274.099 208.561 274.406 207.845 274.764C207.691 274.841 207.537 274.918 207.384 274.995C207.281 275.046 207.179 275.097 207.077 275.174C206.872 275.302 206.667 275.404 206.462 275.532C206.411 275.558 206.36 275.584 206.309 275.635C206.257 275.66 206.206 275.686 206.155 275.712C205.925 275.84 205.72 275.968 205.489 276.121C205.464 276.147 205.413 276.172 205.387 276.172C205.285 276.249 205.182 276.3 205.08 276.377C204.926 276.48 204.773 276.582 204.645 276.684L205.489 268.723C206.462 268.288 207.486 267.904 208.485 267.571C209.841 267.084 211.249 266.752 212.683 266.547Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M209.663 314.623L209.279 320.767C206.156 319.871 203.161 318.437 200.447 316.441L201.164 309.759V309.733C201.343 309.913 201.522 310.066 201.727 310.22C204.082 312.268 206.796 313.727 209.663 314.623Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M234.315 272.332L233.394 279.039L233.368 279.142C233.214 278.962 233.061 278.783 232.907 278.604C231.269 277.042 229.451 275.788 227.531 274.815V274.79L228.53 268.748C230.552 269.695 232.498 270.898 234.315 272.332Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M228.837 311.653L227.736 319.641C225.202 320.716 222.565 321.381 219.852 321.663L220.927 315.084C223.717 314.495 226.405 313.343 228.837 311.653Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.891 300.441L229.298 302.95L225.867 306.15L223.563 303.769C221.183 305.792 218.418 307.302 216.267 307.763L214.245 302.233C216.575 301.67 219.109 300.339 220.824 298.675C222.335 297.216 222.565 296.396 222.053 295.833C220.133 293.862 212.965 303.846 207.307 297.958C204.85 295.424 204.645 291.507 207.845 287.436L205.055 284.544L208.229 281.497L210.968 284.339C212.786 282.905 214.808 281.753 216.805 281.241L218.904 286.617C216.6 287.334 214.757 288.358 213.4 289.664C211.839 291.148 211.787 292.096 212.299 292.633C214.117 294.528 221.311 284.569 226.891 290.355C229.272 292.812 229.784 296.473 226.891 300.441Z",
    fill: "#BB9132"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M226.353 299.878L228.76 302.361L225.611 305.408L223.332 303.027C220.952 305.049 218.212 306.534 216.062 306.995L214.065 301.516C216.395 300.953 218.904 299.622 220.619 297.958C222.129 296.524 222.36 295.68 221.848 295.142C219.953 293.171 212.811 303.104 207.179 297.267C204.747 294.732 204.516 290.841 207.716 286.796L205.361 284.364L208.51 281.318L210.814 283.724C212.632 282.291 214.654 281.164 216.6 280.652L218.699 286.003C216.395 286.72 214.577 287.718 213.22 289.049C211.684 290.534 211.608 291.456 212.12 291.993C213.937 293.862 221.08 283.955 226.66 289.74C228.939 292.147 229.22 295.936 226.353 299.878Z",
    fill: "#FBC343"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_247_1619",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 280,
    width: 24,
    height: 27
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M226.353 299.878L228.76 302.361L225.611 305.408L223.332 303.027C220.952 305.049 218.212 306.534 216.062 306.995L214.065 301.516C216.395 300.953 218.904 299.622 220.619 297.958C222.129 296.524 222.36 295.68 221.848 295.142C219.953 293.171 212.811 303.104 207.179 297.267C204.747 294.732 204.516 290.841 207.716 286.796L205.361 284.364L208.51 281.318L210.814 283.724C212.632 282.291 214.654 281.164 216.6 280.652L218.699 286.003C216.395 286.72 214.577 287.718 213.22 289.049C211.684 290.534 211.608 291.456 212.12 291.993C213.937 293.862 221.08 283.955 226.66 289.74C228.939 292.147 229.22 295.936 226.353 299.878Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_247_1619)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M203.569 257.971L195.838 330.982L206.743 332.083L211.377 258.227L203.569 257.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M217.418 337.407L231.293 252.723L237.975 254.463L226.071 340.044L217.418 337.407Z",
    fill: "white"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M221.131 288.845L219.339 294.144C219.339 294.144 214.399 300.262 215.09 301.03C216.549 302.643 220.338 298.726 220.338 298.726L217.266 306.534C217.087 307.046 217.419 307.61 217.931 307.712C219.595 308.096 223.077 308.429 226.226 305.971C230.322 302.771 229.349 295.04 229.349 295.04L231.09 289.331L221.131 288.845Z",
    fill: "#F9B384"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M237.567 271.001L235.903 277.631L235.877 277.759L235.621 278.809L232.754 290.227L229.068 290.355L228.095 290.38L218.623 290.687L218.777 289.945L218.93 289.228L219.417 286.924L219.57 286.207L220.645 280.934L220.773 280.243L222.233 273.177L222.591 271.385L222.617 271.359L224.153 264.063C225.586 264.268 226.994 264.575 228.351 265.011C231.807 266.035 236.978 266.931 237.567 271.001Z",
    fill: "#708CD5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M123.289 147.942C120.678 135.91 108.723 128.332 96.6908 131.123C85.2732 133.785 77.8492 145.1 79.974 156.646C80.998 162.15 83.942 166.758 87.9612 169.958C91.1356 172.492 93.3884 175.999 94.2332 179.967L119.859 174.387C118.988 170.419 119.552 166.297 121.395 162.687C123.622 158.284 124.416 153.113 123.289 147.942Z",
    fill: "#FBC343"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8715 152.754L95.0268 152.37C94.1564 151.961 93.1324 152.626 93.2092 153.573C93.2348 153.727 93.2604 153.906 93.3372 154.06L104.78 179.045L110.105 177.893V150.425C110.105 150.373 110.105 150.322 110.105 150.245C109.977 149.145 108.518 148.786 107.827 149.657L107.52 150.041C104.678 153.471 99.8907 154.597 95.8715 152.754Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M111.3 196.668C113.621 196.162 115.263 194.654 114.968 193.301C114.672 191.947 112.552 191.26 110.231 191.766C107.911 192.272 106.269 193.78 106.564 195.134C106.859 196.487 108.98 197.174 111.3 196.668Z",
    fill: "#102048"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2324 179.968L119.832 174.361L122.162 185.037L96.562 190.694L94.2324 179.968Z",
    fill: "#1F3C88"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5117 190.437L122.137 184.856L120.422 188.901C119.603 190.847 117.888 192.255 115.814 192.716L105.6 194.968C103.526 195.429 101.35 194.84 99.7885 193.407C98.2269 191.999 96.5117 190.437 96.5117 190.437Z",
    fill: "#1F3C88"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M122.444 179.967L94.3353 186.111C93.9257 186.213 93.4905 185.932 93.4137 185.522C93.3113 185.113 93.5929 184.677 94.0025 184.601L122.111 178.457C122.521 178.354 122.956 178.636 123.033 179.045C123.135 179.455 122.854 179.89 122.444 179.967Z",
    fill: "#708CD5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M123.673 185.651L95.5638 191.769C95.1542 191.871 94.719 191.59 94.6422 191.18C94.5398 190.771 94.8214 190.335 95.231 190.259L123.34 184.14C123.749 184.038 124.185 184.319 124.261 184.729C124.364 185.139 124.108 185.548 123.673 185.651Z",
    fill: "#708CD5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9336 119.808L84.7608 126.873",
    stroke: "#FBC343",
    strokeWidth: 14.3432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M108.8 106.572L102.707 120.78",
    stroke: "#FBC343",
    strokeWidth: 14.3432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8066 106.061L93.0034 121.216",
    stroke: "#FBC343",
    strokeWidth: 14.3432,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 322.278H279.832V329.165H335.461V322.278Z",
    fill: "#FBC343"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 322.278H294.348V329.165H317.183V322.278Z",
    fill: "#BB9132"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 322.278H284.133V329.165H289.406V322.278Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 322.278H324.658V329.165H329.932V322.278Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 336.051H279.832V342.937H335.461V336.051Z",
    fill: "#FBC343"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 336.051H294.348V342.937H317.183V336.051Z",
    fill: "#BB9132"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 336.051H284.133V342.937H289.406V336.051Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 336.051H324.658V342.937H329.932V336.051Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M333.49 329.139H277.861V336.025H333.49V329.139Z",
    fill: "#FBC343"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M315.212 329.139H292.377V336.025H315.212V329.139Z",
    fill: "#BB9132"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M287.436 329.139H282.162V336.025H287.436V329.139Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M327.961 329.139H322.688V336.025H327.961V329.139Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 349.798H279.832V356.684H335.461V349.798Z",
    fill: "#FBC343"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 349.798H294.348V356.684H317.183V349.798Z",
    fill: "#BB9132"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 349.798H284.133V356.684H289.406V349.798Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 349.798H324.658V356.684H329.932V349.798Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M338.277 342.912H282.648V349.799H338.277V342.912Z",
    fill: "#FBC343"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M319.999 342.912H297.164V349.799H319.999V342.912Z",
    fill: "#BB9132"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M292.223 342.912H286.949V349.799H292.223V342.912Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M332.748 342.912H327.475V349.799H332.748V342.912Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 363.571H279.832V370.458H335.461V363.571Z",
    fill: "#FBC343"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 363.571H294.348V370.458H317.183V363.571Z",
    fill: "#BB9132"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 363.571H284.133V370.458H289.406V363.571Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 363.571H324.658V370.458H329.932V363.571Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M332.928 356.685H277.299V363.571H332.928V356.685Z",
    fill: "#FBC343"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M314.65 356.685H291.814V363.571H314.65V356.685Z",
    fill: "#BB9132"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M286.873 356.685H281.6V363.571H286.873V356.685Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M327.399 356.685H322.125V363.571H327.399V356.685Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 377.344H279.832V384.23H335.461V377.344Z",
    fill: "#FBC343"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 377.344H294.348V384.23H317.183V377.344Z",
    fill: "#BB9132"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 377.344H284.133V384.23H289.406V377.344Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 377.344H324.658V384.23H329.932V377.344Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 370.457H279.832V377.343H335.461V370.457Z",
    fill: "#FBC343"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 370.457H294.348V377.343H317.183V370.457Z",
    fill: "#BB9132"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 370.457H284.133V377.343H289.406V370.457Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 370.457H324.658V377.343H329.932V370.457Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M331.365 391.117H275.736V398.004H331.365V391.117Z",
    fill: "#FBC343"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M313.087 391.117H290.252V398.004H313.087V391.117Z",
    fill: "#BB9132"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M285.311 391.117H280.037V398.004H285.311V391.117Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M325.836 391.117H320.562V398.004H325.836V391.117Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 384.23H279.832V391.117H335.461V384.23Z",
    fill: "#FBC343"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 384.23H294.348V391.117H317.183V384.23Z",
    fill: "#BB9132"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 384.23H284.133V391.117H289.406V384.23Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 384.23H324.658V391.117H329.932V384.23Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 404.915H279.832V411.801H335.461V404.915Z",
    fill: "#FBC343"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 404.915H294.348V411.801H317.183V404.915Z",
    fill: "#BB9132"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 404.915H284.133V411.801H289.406V404.915Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 404.915H324.658V411.801H329.932V404.915Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 398.028H279.832V404.915H335.461V398.028Z",
    fill: "#FBC343"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 398.028H294.348V404.915H317.183V398.028Z",
    fill: "#BB9132"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 398.028H284.133V404.915H289.406V398.028Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 398.028H324.658V404.915H329.932V398.028Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 418.688H279.832V425.574H335.461V418.688Z",
    fill: "#FBC343"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 418.688H294.348V425.574H317.183V418.688Z",
    fill: "#BB9132"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 418.688H284.133V425.574H289.406V418.688Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 418.688H324.658V425.574H329.932V418.688Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 411.802H279.832V418.688H335.461V411.802Z",
    fill: "#FBC343"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 411.802H294.348V418.688H317.183V411.802Z",
    fill: "#BB9132"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 411.802H284.133V418.688H289.406V411.802Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 411.802H324.658V418.688H329.932V411.802Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 432.461H279.832V439.347H335.461V432.461Z",
    fill: "#FBC343"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 432.461H294.348V439.347H317.183V432.461Z",
    fill: "#BB9132"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 432.461H284.133V439.347H289.406V432.461Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 432.461H324.658V439.347H329.932V432.461Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 425.574H279.832V432.461H335.461V425.574Z",
    fill: "#FBC343"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 425.574H294.348V432.461H317.183V425.574Z",
    fill: "#BB9132"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 425.574H284.133V432.461H289.406V425.574Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 425.574H324.658V432.461H329.932V425.574Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M335.461 439.373H279.832V446.259H335.461V439.373Z",
    fill: "#FBC343"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M317.183 439.373H294.348V446.259H317.183V439.373Z",
    fill: "#BB9132"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M289.406 439.373H284.133V446.259H289.406V439.373Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M329.932 439.373H324.658V446.259H329.932V439.373Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M408.215 349.798H352.586V356.684H408.215V349.798Z",
    fill: "#FBC343"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M389.937 349.798H367.102V356.684H389.937V349.798Z",
    fill: "#BB9132"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M362.16 349.798H356.887V356.684H362.16V349.798Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M402.686 349.798H397.412V356.684H402.686V349.798Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M401.381 363.57H345.752V370.457H401.381V363.57Z",
    fill: "#FBC343"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.103 363.57H360.268V370.457H383.103V363.57Z",
    fill: "#BB9132"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.326 363.57H350.053V370.457H355.326V363.57Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M395.852 363.57H390.578V370.457H395.852V363.57Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M398.846 356.685H343.217V363.571H398.846V356.685Z",
    fill: "#FBC343"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M380.568 356.685H357.732V363.571H380.568V356.685Z",
    fill: "#BB9132"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M352.791 356.685H347.518V363.571H352.791V356.685Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M393.317 356.685H388.043V363.571H393.317V356.685Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M401.381 377.344H345.752V384.23H401.381V377.344Z",
    fill: "#FBC343"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.103 377.344H360.268V384.23H383.103V377.344Z",
    fill: "#BB9132"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.326 377.344H350.053V384.23H355.326V377.344Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M395.852 377.344H390.578V384.23H395.852V377.344Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M398.564 370.457H342.936V377.343H398.564V370.457Z",
    fill: "#FBC343"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M380.286 370.457H357.451V377.343H380.286V370.457Z",
    fill: "#BB9132"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M352.51 370.457H347.236V377.343H352.51V370.457Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M393.035 370.457H387.762V377.343H393.035V370.457Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M401.381 391.116H345.752V398.003H401.381V391.116Z",
    fill: "#FBC343"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.103 391.116H360.268V398.003H383.103V391.116Z",
    fill: "#BB9132"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.326 391.116H350.053V398.003H355.326V391.116Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M395.852 391.116H390.578V398.003H395.852V391.116Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M401.381 384.229H345.752V391.116H401.381V384.229Z",
    fill: "#FBC343"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.103 384.229H360.268V391.116H383.103V384.229Z",
    fill: "#BB9132"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.326 384.229H350.053V391.116H355.326V384.229Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M395.852 384.229H390.578V391.116H395.852V384.229Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M406.834 404.915H351.205V411.801H406.834V404.915Z",
    fill: "#FBC343"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M388.556 404.915H365.721V411.801H388.556V404.915Z",
    fill: "#BB9132"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M360.779 404.915H355.506V411.801H360.779V404.915Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M401.305 404.915H396.031V411.801H401.305V404.915Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M401.381 398.028H345.752V404.915H401.381V398.028Z",
    fill: "#FBC343"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.103 398.028H360.268V404.915H383.103V398.028Z",
    fill: "#BB9132"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.326 398.028H350.053V404.915H355.326V398.028Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M395.852 398.028H390.578V404.915H395.852V398.028Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M401.381 418.688H345.752V425.574H401.381V418.688Z",
    fill: "#FBC343"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.103 418.688H360.268V425.574H383.103V418.688Z",
    fill: "#BB9132"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.326 418.688H350.053V425.574H355.326V418.688Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M395.852 418.688H390.578V425.574H395.852V418.688Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M401.381 411.801H345.752V418.687H401.381V411.801Z",
    fill: "#FBC343"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.103 411.801H360.268V418.687H383.103V411.801Z",
    fill: "#BB9132"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.326 411.801H350.053V418.687H355.326V411.801Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M395.852 411.801H390.578V418.687H395.852V411.801Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M401.381 432.46H345.752V439.346H401.381V432.46Z",
    fill: "#FBC343"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.103 432.46H360.268V439.346H383.103V432.46Z",
    fill: "#BB9132"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.326 432.46H350.053V439.346H355.326V432.46Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M395.852 432.46H390.578V439.346H395.852V432.46Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M401.381 425.574H345.752V432.461H401.381V425.574Z",
    fill: "#FBC343"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.103 425.574H360.268V432.461H383.103V425.574Z",
    fill: "#BB9132"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.326 425.574H350.053V432.461H355.326V425.574Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M395.852 425.574H390.578V432.461H395.852V425.574Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M401.381 439.372H345.752V446.258H401.381V439.372Z",
    fill: "#FBC343"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M383.103 439.372H360.268V446.258H383.103V439.372Z",
    fill: "#BB9132"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.326 439.372H350.053V446.258H355.326V439.372Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M395.852 439.372H390.578V446.258H395.852V439.372Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M375.773 344.446L331.275 311.058L327.142 316.566L371.64 349.954L375.773 344.446Z",
    fill: "#FBC343"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M361.151 333.448L342.885 319.742L338.752 325.251L357.017 338.956L361.151 333.448Z",
    fill: "#BB9132"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M338.935 316.791L334.717 313.626L330.584 319.134L334.802 322.3L338.935 316.791Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M371.351 341.109L367.133 337.943L363 343.452L367.218 346.617L371.351 341.109Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1133 445.824H448.051",
    stroke: "#102048",
    strokeWidth: 3.75,
    strokeMiterlimit: 10
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M354.508 128.665H255.129C256.767 121.241 264.115 115.635 272.921 115.635C275.558 115.635 278.067 116.147 280.319 117.043C283.596 108.211 291.174 101.99 299.98 101.99C308.633 101.99 316.083 107.955 319.462 116.531C322.943 114.995 326.988 114.125 331.289 114.125C342.809 114.125 352.409 120.371 354.508 128.665Z",
    fill: "#EDF2FF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M358.707 222.847H436.429C435.149 217.036 429.414 212.659 422.528 212.659C420.48 212.659 418.509 213.043 416.742 213.759C414.182 206.847 408.243 201.983 401.357 201.983C394.573 201.983 388.761 206.643 386.125 213.35C383.411 212.147 380.237 211.455 376.883 211.455C367.846 211.481 360.345 216.371 358.707 222.847Z",
    fill: "#EDF2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiringEngagement);
export default __webpack_public_path__ + "static/media/hiring_engagement.4671f3399b6988033ad2064b7f8fc3e0.svg";
export { ForwardRef as ReactComponent };